(function () {
  var bq = window.bq;
  if (!bq) return;

  function init(root) {
    if (!root || root.dataset.bqFaqInit) return;
    root.dataset.bqFaqInit = '1';

    var reduced = bq.reducedMotion();

    if (window.bqReveal) window.bqReveal(root, '[data-faq-reveal]');

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));

    var railLinks = Array.prototype.slice.call(root.querySelectorAll('[data-rail-target]'));
    railLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.dataset.railTarget);
        if (!target) return;
        e.preventDefault();
        // Mark active immediately: the scroll-spy misses fast jumps.
        railLinks.forEach(function (x) { x.classList.toggle('is-active', x === a); });
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + a.dataset.railTarget);
      });
    });
    if ('IntersectionObserver' in window && railLinks.length) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          railLinks.forEach(function (a) {
            a.classList.toggle('is-active', a.dataset.railTarget === en.target.id);
          });
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      groups.forEach(function (gp) { spy.observe(gp); });
    }

    var input = root.querySelector('[data-faq-search]');
    var clearBtn = root.querySelector('[data-faq-clear]');
    var emptyEl = root.querySelector('[data-faq-empty]');
    var resetBtn = root.querySelector('[data-faq-reset]');

    function applyFilter(raw) {
      var q = bq.norm(raw.trim());
      var total = 0;
      groups.forEach(function (gp) {
        var visible = 0;
        gp.querySelectorAll('[data-faq-item]').forEach(function (item) {
          var hit = !q || bq.norm(item.textContent).indexOf(q) !== -1;
          item.hidden = !hit;
          if (hit) visible++;
        });
        gp.hidden = visible === 0;
        total += visible;
        var link = railLinks.filter(function (a) { return a.dataset.railTarget === gp.id; })[0];
        if (link) link.parentElement.classList.toggle('is-empty', visible === 0);
      });
      if (emptyEl) emptyEl.hidden = total !== 0;
      if (clearBtn) clearBtn.hidden = !q;
    }

    if (input) {
      var deb;
      input.addEventListener('input', function () {
        clearTimeout(deb);
        deb = setTimeout(function () { applyFilter(input.value); }, 120);
      });

      // Virtual-keyboard submit/search key (Android "search", iOS "Go"/
      // "Search"): filtering already runs live on each keystroke, so submitting
      // just means "done". Blur the input to close the keyboard (it stays open
      // otherwise). Two paths depending on the keyboard: an Enter keydown or a
      // form submit without keydown, so handle both. The form already uses
      // onsubmit=return false (no reload).
      var closeKeyboard = function () {
        clearTimeout(deb);
        applyFilter(input.value);
        try { input.blur(); } catch (e) {}
      };
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          closeKeyboard();
        }
      });
      var searchForm = input.form || input.closest('form');
      if (searchForm) {
        searchForm.addEventListener('submit', function (e) {
          e.preventDefault();
          closeKeyboard();
        });
      }
    }
    function resetSearch() {
      if (!input) return;
      input.value = '';
      applyFilter('');
      input.focus();
    }
    if (clearBtn) clearBtn.addEventListener('click', resetSearch);
    if (resetBtn) resetBtn.addEventListener('click', resetSearch);

    bq.wireNuwa(root, '[data-faq-nuwa]');
  }

  document.querySelectorAll('.bq-faq').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bq-faq').forEach(init);
  });
})();
